const ShippingOrderType = {
    Order: "Order",
    Collection: "Collection",
};

export default ShippingOrderType;
